import { UserModel } from "../context/AuthContextProvider"
import { restErrorHandler } from "../helpers/restErrorHandler"
import Organization from "../pages/Organization/Organization"


export const NoRole = 0
export const Client = 1
export const Factory = 6
export const Service = 7
export const Support = 8


export const ClientMethodRole = "client"
export const StaffMethodRole = "staff"

type Role = "client" | "factory" | "service" | "support" | "norole"

function roleMap(role:number): Role {
    switch (role) {
        case NoRole: 
            return "norole"; 
        case Client: 
            return "client";
        case Factory: 
            return "factory";
        case Service: 
            return "service";
        case Support: 
            return "support";
        default: 
            return "norole"
    }
}


type Permissions = {
    [resourse: string]: {
        [action: string]: {
            [client: string]: string[];
        }
    }
};


const Permisions: Permissions = {
    AcbView : {
        view : {
            allowedRoles: ['factory', 'service', 'support', 'client']
        },
        editBtn : {
            allowedRoles: ['support', 'client']
        },
        changeOrganization: {
            allowedRoles: ['support']
        }
    },
    AcbList : {
        view: {
            allowedRoles: ['factory', 'service', 'support']
        },
        create: {
            allowedRoles: ['factory', 'service']
        }
    },
    OwnOrganization : {
        view: {
            allowedRoles: ['client']
        }
    },
    Commission : {
        view: {
            allowedRoles: ['factory', 'service', 'support']
        },
        update: {
            allowedRoles: ['factory']
        },
        updateComment: {
            allowedRoles: ['factory', 'service', 'support']
        },
        setCommissionOptions: {
            allowedRoles: ['service']
        }
    },
    Users: {
        view: {
            allowedRoles: ['support']
        },
        create: { 
            allowedRoles: ['support']
        },
        update: {
            allowedRoles: ['factory', 'service', 'support', 'client']
        }
    },
    Organization : {
        list : {
            allowedRoles: ['support', 'service']
        },
        create : {
            allowedRoles: ['support']
        },
        details: {
            allowedRoles: ['support', 'service', 'client']
        },
        update: {
            allowedRoles: ['support', 'client']
        },
        delete: {
            allowedRoles: ['support', 'client']
        }
    },
    Building : {
        list : {
            allowedRoles: ['support', 'service', 'client']
        },
        create : {
            allowedRoles: ['support', 'client']
        },
        details: {
            allowedRoles: ['support', 'service', 'client']
        },
        update: {
            allowedRoles: ['support', 'client']
        },
        delete: {
            allowedRoles: ['support', 'client']
        },
    },
    Device : {
        list : {
            allowedRoles: ['support', 'service', 'client']
        },
        create : {
            allowedRoles: ['support', 'client']
        },
        details: {
            allowedRoles: ['support', 'service', 'client']
        },
        update: {
            allowedRoles: ['support', 'client']
        },
        delete: {
            allowedRoles: ['support', 'client']
        },
    },
    OS: {
        view: {
            allowedRoles: ['support', 'service']
        }
    }
}


interface hasPermissionProps {
    role: number;
    resource: string;
    action: string;
}


export const hasPermission = ({ role, resource, action }:hasPermissionProps):boolean => {
    // return Permisions[roleMap(role)]?.[resource]?.[action] ?? false;
    return Permisions[resource]?.[action]?.['allowedRoles'].includes(roleMap(role)) ?? false
}


export const useValidatePermission = ({ role, resource, action }:hasPermissionProps):void => {
    // If user has no permission, than redirected to 403
    const hasPermission = Permisions[resource]?.[action]?.['allowedRoles'].includes(roleMap(role)) ?? false
    if (!hasPermission) {
        restErrorHandler(403)
    }
}